import React, { createContext } from "react";
import { useQuery } from "react-query";
import { USERS } from "../config/apiConfig";
import { getUserId } from "../utils/permissions";
import axios from "../config/axiosInstance";

const ApplicationContext = createContext();

const PermissionProvider = ({ children }) => {
  const { data: user, refetch } = useQuery(["user"], async () => {
    try {
      const { data } = await axios.get(`${USERS.GET_USER_CURRENT}`);

      return data.data;
    } catch (error) {
      return "USER";
    }
  });

  return (
    <ApplicationContext.Provider
      value={{ user, userPermission: user?.permissionId, refetchUser: refetch }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

const useApplication = () => React.useContext(ApplicationContext);

export { PermissionProvider, useApplication };
